const html = (key) => window.html(key);

const toast = ({
    columns = 10,
    id,
    languageCode,
    message,
    messageId,
    showDismissButton,
    toasterType,
}) => `
    <div class="Toaster-toast js-toast ${toasterType} animated fadeIn" role="alert">
        <div class="row">
            <div class="large-${columns} large-centered medium-${columns} medium-centered columns">
                <div class="Toaster-bread">
                    <div role="alert" 
                        class="Toaster-message js-toastMessage Toaster-messageContent" 
                        id="${id}" 
                        data-message-id="${messageId}"
                        ${languageCode ? `lang="${languageCode}"` : ''}
                    >
                        ${message}
                    </div>
                    
                    ${
                        showDismissButton
                            ? `
                        <button 
                            aria-label="${html('toasts.dismissAria')}"
                            class="js-closeToast Toaster-close">
                            &times;
                        </button>
                    `
                            : ''
                    }
                </div>
            </div>
        </div>
    </div>
`;

export const standardToast = ({ id, languageCode, message, messageId, toasterType }) =>
    toast({ id, languageCode, message, messageId, showDismissButton: true, toasterType });
